import PropTypes from 'prop-types';
import { ItemsAll } from '../../components/Views/ItemsAll';
import { getSeoData, getValueFromObject } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import {
  setAdriverSelectedCity,
  setCurrentState,
  setSearchSort
} from '../../actions';
import { BUILDING_TYPE_ID, Cities } from '../../utils/helpers/constants';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getDataForTransformationsQuery } from '../../api/queries';
import { ItemConnectionSort } from '../../graphql/types';

const App = ({ sortingValue, ...rest }) => (
  <ItemsAll {...{ sortingValue, ...rest }} />
);

App.getInitialProps = async ({ apolloClient, asPath, req, query, store }) => {
  const [dataForTransform, seoData] = await Promise.all([
    apolloClient.query({ query: getDataForTransformationsQuery }),
    getSeoData(apolloClient, asPath, req),
    getStaticData(apolloClient, true)
  ]);

  const sortingValue = query.sorting;

  const sortingName = getValueFromObject(
    dataForTransform.data.sort,
    sortingValue,
    'name'
  );

  const storedFormState = store.getState().searchForm.currentState;
  store.dispatch(
    setCurrentState({
      ...storedFormState,
      city_id: Cities.Baku.id,
      category_id: BUILDING_TYPE_ID.FLAT_ALL,
      leased: 'false',
      sorting: sortingName
    })
  );
  store.dispatch(setAdriverSelectedCity(Cities.Baku.az));

  store.dispatch(setSearchSort(sortingName || ItemConnectionSort.BumpedAtDesc));

  return {
    sortingValue: sortingName,
    seoData
  };
};

App.propTypes = {
  sortingValue: PropTypes.string
};

App.getLayout = (page, pageProps) => (
  <Layout isBackgroundBanner pageProps={pageProps}>
    {page}
  </Layout>
);

export default App;
